import { JbContactOverlay } from '@bjb/bjb-web-components/dist/components/jb-contact-overlay/jb-contact-overlay.js';

document.body.addEventListener('jb-link:clicked', (event) => {
  if (!event.detail.contactOverlay) {
    return;
  }

  if (event.detail.clickEvent) {
    event.detail.clickEvent.preventDefault();
    event.detail.clickEvent.stopPropagation();
  }
  event.stopPropagation();

  const contactOverlayProps = {
    ...event.detail.contactOverlay,
  };

  const modalProps = {
    ...event.detail.modal,
    color: 'white',
    hasLogo: true,
    newAnimation: true,
    returnFocusTo: event.detail.linkTag,
  };
  // open() types its arguments as the element interfaces (IModal extends LitElement) although it
  // only reads props off them; remove once storybook types them as props.
  // @ts-expect-error
  JbContactOverlay.open(modalProps, contactOverlayProps).then();
});
